import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

export interface AdminCalendarEvent {
  id: number;
  start_date: string;
  end_date: string | null;
  title_ka: string | null;
  title_en: string | null;
  description_ka: string | null;
  description_en: string | null;
  url: string | null;
  target: '_self' | '_blank';
  color: string;
  sort_order: number;
  is_active: boolean | number;
  created_at?: string;
  updated_at?: string;
}

export interface AdminCalendarEventsListRes {
  status: 'success' | 'error';
  items: {
    data: AdminCalendarEvent[];
    current_page: number;
    last_page: number;
    total: number;
  };
}

export interface AdminCalendarEventRes {
  status: 'success' | 'error';
  item: AdminCalendarEvent;
}

export interface AdminCalendarEventDaysRes {
  status: 'success' | 'error';
  month: string | null;
  days: number[];
  counts: Record<number, number>;
}

@Injectable({ providedIn: 'root' })
export class CalendarAdminService {
  private api = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getEventDays(month: string) {
    return this.http.get<AdminCalendarEventDaysRes>(`${this.api}calendar/event-days`, {
      params: { month }
    });
  }

  getEventsByDate(date: string) {
    return this.http.get<{ status: 'success' | 'error'; items: AdminCalendarEvent[] }>(
      `${this.api}admin/calendar-events`,
      {
        params: {
          date_from: date,
          date_to: date
        }
      }
    );
  }

  list(params: any = {}) {
    return this.http.get<AdminCalendarEventsListRes>(`${this.api}admin/calendar-events`, {
      params
    });
  }

  get(id: number) {
    return this.http.get<AdminCalendarEventRes>(`${this.api}admin/calendar-events/${id}`);
  }

  create(payload: any) {
    return this.http.post<AdminCalendarEventRes>(`${this.api}admin/calendar-events`, payload);
  }

  update(id: number, payload: any) {
    return this.http.post<AdminCalendarEventRes>(`${this.api}admin/calendar-events/${id}`, payload);
  }

  delete(id: number) {
    return this.http.delete<{ status: 'success' | 'error' }>(`${this.api}admin/calendar-events/${id}`);
  }

  reorder(items: { id: number; sort_order: number }[]) {
    return this.http.post<{ status: 'success' | 'error' }>(
      `${this.api}admin/calendar-events/reorder`,
      { items }
    );
  }
}